import { render, staticRenderFns } from "./DetailModalConversation.vue?vue&type=template&id=7448c15d&scoped=true"
import script from "./DetailModalConversation.vue?vue&type=script&lang=js"
export * from "./DetailModalConversation.vue?vue&type=script&lang=js"
import style0 from "./DetailModalConversation.vue?vue&type=style&index=0&id=7448c15d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7448c15d",
  null
  
)

export default component.exports